import { Base } from '@itsrever/design-system'
import { clsx } from 'clsx'

interface CheckboxOptionProps {
  label: string
  checked: boolean
  onCheckedChange: () => void
  size?: 'sm' | 'md'
}

export const CheckboxOption: React.FC<CheckboxOptionProps> = ({
  label,
  checked,
  onCheckedChange,
  size = 'md'
}) => (
  <label className="flex cursor-pointer items-center gap-2 py-0.5">
    <Base.Checkbox
      size="sm"
      checked={checked}
      onCheckedChange={onCheckedChange}
    />
    <span
      className={clsx(
        'text-neutral-900',
        size === 'sm' ? 'text-sm' : 'text-base'
      )}
    >
      {label}
    </span>
  </label>
)
